import { ItemNode, ItemNodeWithParent } from '../models/item';
export class ItemNodeUtils {

  itemListHt: any = {};

  constructor(private itemList: ItemNode[]) {
    itemList.forEach(item => {
      this.addNodeToHt(item, null);
    });
  }

  private addNodeToHt(item: ItemNode, _parentId: string) {
    const itemNodeWithParent = new ItemNodeWithParent(item);
    itemNodeWithParent.parentId = _parentId;
    this.itemListHt[item.Id] = itemNodeWithParent;
    const children = item.children;
    if (children) {
      const parentId = item.Id;
      children.forEach(child => {
        this.addNodeToHt(child, parentId);
      });
    }
  }

  getParent(item: ItemNode): ItemNode {
    let result = null;
    if (item) {
      const parentId = this.itemListHt[item.Id].parentId;
      if (parentId) {
        result = this.itemListHt[parentId].itemNode;
      }
    }
    return result;
  }

  getNextSibling(item: ItemNode): ItemNode {
    let result = null;
    const parent = this.getParent(item);
    if (parent) {
      const itemIndex = this.getItemIndex(item, parent.children);
      const lastIndex = parent.children.length - 1;
      if (itemIndex < lastIndex) {
        result = parent.children[itemIndex + 1];
      } else if (itemIndex === lastIndex) {
        result = parent.children[0];
      }
    } else { // nodo primo livello
      const itemIndex = this.getItemIndex(item, this.itemList);
      const lastIndex = this.itemList.length - 1;
      if (itemIndex === null) {
        result = this.itemList[0];
      } else if (itemIndex < lastIndex) {
        result = this.itemList[itemIndex + 1];
      }
    }
    return result;
  }

  getPreviousSibling(item: ItemNode): ItemNode {
    let result = null;
    const parent = this.getParent(item);
    if (parent) {
      const itemIndex = this.getItemIndex(item, parent.children);
      const lastIndex = parent.children.length - 1;
      if (itemIndex === 0) {
        result = parent.children[lastIndex];
      } else if (itemIndex > 0) {
        result = parent.children[itemIndex - 1];
      }
    } else { // nodo primo livello
      const itemIndex = this.getItemIndex(item, this.itemList);
      const lastIndex = this.itemList.length - 1;
      if (itemIndex === null) {
        result = this.itemList[lastIndex];
      } else if (itemIndex > 0) {
        result = this.itemList[itemIndex - 1];
      }
    }
    return result;
  }

  getItemIndex(item: ItemNode, children: ItemNode[]): number {
    let result = null;
    if (item) {
      for (let index = 0; index < children.length; index++) {
        const child = children[index];
        if (child.Id === item.Id) {
          result = index;
          break;
        }
      }
    }
    return result;
  }

  findNodeById(guid: string) {
    return this.itemListHt[guid].itemNode;
  }

}
